import React from 'react'
import { StyleSheetManager, ThemeProvider } from 'styled-components'

import { GlobalStyles } from '@/components/providers/styled-components-theme-provider/styled-components-theme-provider.styled'
import { theme } from '@/theme/theme'

export interface StyledComponentsThemeProviderProps {
  children: React.ReactNode
}

export const StyledComponentsThemeProvider = ({ children }: StyledComponentsThemeProviderProps) => {
  return (
    <StyleSheetManager enableVendorPrefixes={true}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </StyleSheetManager>
  )
}
